import React, { useEffect, useState } from 'react'
import { useStateValue } from '../Utils/StateProvider'

import { ImWarning } from 'react-icons/im'
import { FcNeutralDecision } from 'react-icons/fc'
import { MdDoneOutline } from 'react-icons/md'
import { GrClose } from 'react-icons/gr'

import '../Styles/Info.css'
import { TbFaceIdError } from 'react-icons/tb'


const Info = () => {
    const [{ notify }, payload] = useStateValue()
    const [infoClass, setInfoClass] = useState('')
    const [icon, setIcon] = useState('')

    const close = () => {
        payload({
            type: 'CLEAR_NOTIFY'
        })
    }

    useEffect(() => {
        if (notify) {
            setInfoClass(`info ${notify?.type || 'default'}`)
            switch(notify?.type) {
                case 'success':
                    setIcon(<MdDoneOutline />)
                    break;
                case 'error':
                    setIcon(<TbFaceIdError />)
                    break;
                case 'warn':
                    setIcon(<ImWarning />)
                    break;
    
                default:
                    setIcon(<FcNeutralDecision />)
            }
        }
    }, [notify])

    return (
        notify && (
            <div className="info-cover">
                <div className={infoClass}>
                    <div className="controls">
                        <GrClose onClick={close} />
                    </div>
                    {icon}
                    <p>{notify?.text}</p>
                </div>
            </div>
        )
    )
}

export default Info
